const locationBn = {
	selector: {
		districtLabel: 'জেলা',
		upazillaLabel: 'উপজেলা',
		bazarLabel: 'বাজার',
		districtSearchPlaceholder: 'জেলা খুঁজুন...',
		upazillaSearchPlaceholder: 'উপজেলা খুঁজুন...',
		bazarSearchPlaceholder: 'বাজার খুঁজুন...'
	},
	popup: {
		title: 'আপনার এলাকা নির্বাচন করুন',
		instruction: 'গ্রামীণ বাজার ব্যবহার করার জন্য আপনার জেলা, উপজেলা এবং বাজার নির্বাচন করুন',
		chooseDistrict: 'জেলা নির্বাচন করুন',
		chooseUpazilla: 'উপজেলা নির্বাচন করুন',
		chooseBazar: 'বাজার নির্বাচন করুন',
		districtSearchPlaceholder: 'জেলা খুঁজুন...',
		upazillaSearchPlaceholder: 'উপজেলা খুঁজুন...',
		bazarSearchPlaceholder: 'বাজার খুঁজুন...',
		selectedPrefix: 'নির্বাচিত:',
		confirm: 'নিশ্চিত করুন'
	}
};

export default locationBn;


